class Semver
{
    constructor(version="", strict = true)
    {
        this._major = 0;
        this._minor = 0;
        this._patch = null;
        this._valid = true;
        this._prerelease = "";
        this._build = "";
        this.setVersion(version, strict);
    }
    static extract(str){
        return new Semver(str, false)
        if(this){
            this.setVersion(str, false);
            return this; 
        }else{
        }
    }
    static parse(version)
    {
        return new Semver(version);
        if(this){
            this.setVersion(version);
            return this;
        }
    }
    setVersion(version, strict = true)
    {
        if(version){
            // 正则表达式来自https://semver.org/lang/zh-CN/
            let regex;
            if(strict)
                regex = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.?(0|[1-9]\d*)?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
            else
                regex =  /(0|[1-9]\d*)\.(0|[1-9]\d*)\.?(0|[1-9]\d*)?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?/;

            const match = version.match(regex);
            console.log("version match", match)
            if(match)
            {
                this._major = parseInt(match[1], 0);
                this._minor = parseInt(match[2], 0);
                this._patch = parseInt(match[3]) || null;
                this._prerelease = match[4] || null;
                this._build = match[5] || null;
                this._valid = true;
            }else{
                this._valid = false;
            }
        }
    }
    setMajor(major)
    {
        this._major = major;
    }
    setMinor(minor)
    {
        this._minor = minor;
    }
    setPatch(patch)
    {
        this._patch = patch;
    }
    setPrerelease(prerelease)
    {
        this._prerelease = prerelease;
    }
    setBuild(build)
    {
        this._build = build;
    }
    major()
    {
        return this._major || 0;
    }
    minor()
    {
        return this._minor || 0;
    }
    patch(){
        return this._patch;
    }
    prerelease()
    {
        return this._prerelease || "";
    }
    build()
    {
        return this._build || "";
    }
    version()
    {
        if(this._valid)
        {
            let version = `${this._major}.${this._minor||0}`;
            if(this._patch != null)
            {
                version += `.${this._patch}`;
            }
            if(this._prerelease)
            {
                version += `-${this._prerelease}`;
            }
            return version;
        }
        return ""
    }
    minorVersion()
    {
        if(this._valid)
        {
            let version =  `${this._major}.${this._minor||0}`;
            return version;
        }
        return ""
    }
    shortVersion()
    {
        if(this._valid)
        {
            let version =  `${this._major}.${this._minor||0}`;
            if(this._patch != null)
            {
                version += `.${this._patch}`;
            }
            return version;
        }
        return ""
    }
    longVersion(){
        if(this._valid)
        {
            let version = `${this._major}.${this._minor||0}`;
            if(this._patch != null)
            {
                version += `.${this._patch}`;
            }
            if(this._prerelease)
            {
                version += `-${this._prerelease}`;
            }
            if(this._build)
            {
                version += `+${this._build}`;
            }
            return version;
        }
        else
        {
            return "";
        }
    }
    toString(){
        return this.longVersion();
    }
    valid(){
        return this._valid;
    }
};

module.exports = Semver


//////////////////
// WEBPACK FOOTER
// ./src/utils/semver.cjs
// module id = q0nu
// module chunks = 1